
import Schema from 'AppReact/schema';
import { makeReadyCard, makeReadyColumn } from 'types';

export default {
  card: Schema(makeReadyCard, 'object', { defaultValue: Schema(makeReadyCard).sampleData() }),
  makeReadyCategories: Schema(makeReadyColumn, 'array', { defaultValue: [] }),
  makeReadyCategory: Schema(makeReadyColumn, 'object', { defaultValue: {} }),
}

